<template>
  <div class="white-container full-page-container common-table">
    <el-form class="search-bar" :inline="true" size="small" style="padding-top:10px">
      <el-form-item label="城市">
        <el-select v-model="search.city" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="教练级别">
        <el-select v-model="search.level" placeholder="选择教练级别">
          <el-option label="全部" value="" />
          <el-option v-for="item in coachLevels" :key="item.id" :label="item.level" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="false" label="合作状态">
        <el-select v-model="search.cooperateStatus" placeholder="选择合作状态">
          <el-option v-for="item in cooperateStatus" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="false" label="运动类型">
        <el-select v-model="search.exerciseType" multiple placeholder="选择运动类型">
          <el-option v-for="item in exerciseType" :key="item.id" :label="item.tagName || ''" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="教练ID">
        <el-input v-model="search.id" :maxlength="64" placeholder="填写教练ID" />
      </el-form-item>
      <el-form-item label="统计周期" class="time-range-form-item duration-form">
        <el-date-picker v-model="search.statisticalPeriod" :picker-options="pickerOptions" type="month" value-format="yyyy-MM" placeholder="请选择活动时间" prefix-icon="el-icon-date" />
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit()">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="exportBtn">
        <svg-icon icon-class="batch" />
        批量导出
      </el-button>
    </div>
    <!--table-->
    <TableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.coach.postTaskDuration" style="width: 100%" @selection-change="selectionItemChange">
      <el-table-column type="selection" width="55" fixed />
      <el-table-column prop="id" label="教练ID" fixed />
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="level" label="级别" width="120">
        <template slot-scope="{row}">
          <el-tag v-show="row.level === '特邀'" class="black-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Master'" class="golden-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Team'" class="red-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="row.level === 'Member'" class="gray-color" size="mini" disable-transitions>{{ row.level }}</el-tag>
          <el-tag v-show="levels && !levels.includes(row.level)" class="gray-color" size="mini" disable-transitions>{{ row.level }}</el-tag>

        </template>
      </el-table-column>
      <el-table-column prop="city" label="所在城市" />
      <el-table-column prop="curMonthTaskDuration" label="当月任务时长（小时）" width="150" />
      <el-table-column prop="totalNumberOfTasks" label="任务总次数" />
      <el-table-column prop="totalTaskDuration" label="任务总时长（小时）" width="150" />
      <el-table-column fixed="right" width="100px" label="操作">
        <template slot-scope="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </TableList>
  </div>
</template>
<script>
import TableList from '@/components/TableList/index.vue';
import moment from 'moment';

export default {
  components: { TableList },
  data() {
    console.log(moment());
    return {
      search: {
        city: '',
        level: '',
        // cooperateStatus: undefined,
        // exerciseType: undefined,
        id: '',
        name: '',
        statisticalPeriod: moment().format("YYYY-MM"),
      },
      selectionId: null,
      cityList: [],
      exerciseType: [], // 下拉运动类型
      cooperateStatus: [
        {
          value: 0,
          label: '合作中',
        },
        {
          value: 1,
          label: '暂停合作',
        },
      ], // 下拉合作类型
      pickerOptions: {
        disabledDate: (value) => {
          return moment(value).isAfter(new Date());
        },
      },
    };
  },
  computed: {
    // 教练级别
    coachSelectVO() {
      return this.$store.state.activity.coachSelectVO.reduce((init, item) => {
        if (!init.includes(item.level) && item.level) init.push(item.level);
        return init;
      }, []);
    },
    // 教练级别
    coachLevels() {
      return this.$store.state.activity.coachLevels;
    },
    levels() {
      // let list = [];
      // this.$store.state.activity.coachLevels.forEach(item => {
      //   item.level && list.push(item.level);
      // });
      // list = [...new Set(list)];
      // console.log(list, 999);
      // return list;
      return ['Master', 'Team', 'Member', '特邀'];
    },
  },
  created() {
    this.getCoachSelect();
  },
  methods: {
    getCoachSelect() {
      this.$Api.coach.getCoachSelect().then(res => {
        this.exerciseType = res.movingSelectVO || [];
        this.cityList = res.cityNames || [];
      });
    },
    edit(row) {
      this.$router.push({ path: '/coach/duration/edit', query: { id: row.id }});
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 当选择项发生变化时会触发该事件
    selectionItemChange(selection) {
      this.selectionId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
    },
    // 导出
    exportBtn() {
      const params = {
        ids: this.selectionId,
        statisticalPeriod: this.search.statisticalPeriod,
      };
      if (!this.selectionId) {
        this.$message.error('请选择需要导出的任务时长');
        return false;
      }
      this.$Api.coach.postExportTask(params);
    },
  },
};
</script>

<style lang="less" scoped>
.golden-color,
.red-color,
.black-color {
  display: inline-block;
  min-width: 80px;
  height: auto;
  text-align: center;
  line-height: 22px;
}
.golden-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(202, 166, 112, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.red-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(220, 0, 25, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.gray-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(155, 155, 155, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
.black-color {
  border: 0;
  padding: 1px 13px;
  background: rgba(0, 0, 0, 1);
  font-family: Noto Sans SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
}
</style>
